import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { Document, Page, pdfjs } from 'react-pdf'

import './AnexoView.css'

const AnexoView = () => {
    const idPed = window.location.pathname.slice(17)
    const idAnexo = window.location.search.slice(1)
    const dados = { idPed: idPed, idAnexo: idAnexo }
    const [pages, setPages] = useState({ numPages: null, pageNumber: 1 })
    const [state, setState] = useState()

    useEffect(() => {
        const url = '/api/anexos/getAnexosPed'
        axios.post(url, dados)
            .then(res => {
                setState(res.data)
            })
            .then()
            .catch(error => {
                alert(error.response.data)
            })
    }, [])

    const onDocumentLoad = ({ numPages }) => {
        setPages({ numPages });
    }

    if (state && state.url) {
        var { pageNumber, numPages } = pages
        const mymeType = state.url.slice(-3)

        if (mymeType === "pdf") {
            return (
                <Document file={state.url} onLoadSuccess={onDocumentLoad} className="pdfDocument">
                    {Array.apply(null, Array(numPages))
                        .map((x, i) => i + 1)
                        .map(page => <Page className="pdfPage" pageNumber={page} />)}
                </Document>
            )
        } else {
            return (
                <img src={state.url} alt="imagem" className='imgAnexo' />
            )
        }
    } else {
        return <div></div>
    }
}

export default AnexoView